import { Component, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectButtonOption } from '../../types/select-button';
import { UBaseInfraComponent } from '../u-base-infra.component';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@Component({
  selector: 'u-toggle-button-group',
  templateUrl: './u-toggle-button-group.component.html',
  styleUrls: ['./u-toggle-button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonToggleModule],
})
export class UToggleButtonGroupComponent extends UBaseInfraComponent {
  options = input<SelectButtonOption[]>([]);
  selectedValue = input<string | string[]>(null);
  
  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter();

  onChangeEvent($event: any) {
    const value = $event.value;
    this.selectedValueChange.emit(value);
  }

  getIconRef() {
    return null;
  }
}
